export default "__VITE_ASSET__CoRxdxXw__"